export default "__VITE_ASSET__CPZTcWEd__"